module.exports = __webpack_public_path__ + "img/animated_logo.468449d.gif";